namespace Ir.Components.Workbook.ToolBar.DrilldownToolBar {
    interface IDrilldownToolBarViewModel {
        config: WorkbookConfig;
        dxToolbarConfig: DevExpress.ui.dxToolbar.Properties;
        
        getPopup: any;
    }

    let editPopupControl;
    export function getViewModel(this: IDrilldownToolBarViewModel, params: any) {
        this.config = params.config as WorkbookConfig;
        this.getPopup = function (popupControl) {
            editPopupControl = popupControl;
        }

        this.dxToolbarConfig = {
            items: getItems(this.config)
        };
    }

    function getItems(config: WorkbookConfig) {
        let forceUpdateDataSource = ko.observable(true);

        let items = [
            {
                location: 'before',
                widget: 'dxButton',
                options: {
                    elementAttr: {
                        class: "intro-drilldown-roll-up",
                    },
                    hint: 'Roll-Up - Top Level',
                    template: `<i class="ms" style="transform: rotate(180deg);">download_for_offline</i> <span>Roll-Up</span>`,
                    onClick(e) {
                        config.activeTabOrWidget().drilldownManager.activeDrilldownIndex(0);
                    },
                },
                disabled: config.workbookHelper.isRootDrilldownLevel,
            },
            {
                location: 'before',
                widget: 'dxButton',
                options: {
                    elementAttr: {
                        class: "intro-drilldown-drill-up",
                    },
                    hint: 'Drill Up',
                    template: `<i class="ms">arrow_circle_up</i> <span>Drill Up</span>`,
                    onClick(e) {
                        let drilldownIndex = config.activeTabOrWidget().drilldownManager.activeDrilldownIndex();
                        if (drilldownIndex > 0) {
                            drilldownIndex--;
                            config.activeTabOrWidget().drilldownManager.activeDrilldownIndex(drilldownIndex);
                        }
                    },
                    disabled: config.workbookHelper.isRootDrilldownLevel,
                },
            },
            {
                location: 'before',
                template: `<span>Next drilldown<span>`,
                visible: !isMobile(),
            },
            {
                location: 'before',
                widget: 'dxLookup',
                options: {
                    elementAttr: {
                        class: "intro-drilldown-select",
                    },
                    items: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        forceUpdateDataSource();//Hack to reload items when changing order

                        let items = this().drilldownManager.reportTemplateListForDrilldown().sort(MappingService.sortFields);
                        return items;
                    }, config.activeTabOrWidget),
                    value: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        let nextDrilldownId = this().drilldownManager.nextDrilldownId();
                        return nextDrilldownId === -1 ? null : nextDrilldownId;
                    }, config.activeTabOrWidget),
                    onValueChanged(e) {
                        let tabOrWidget = config.activeTabOrWidget();

                        if (e.value === -1 || tabOrWidget.drilldownManager.getNextDrilldown()?.id == e.value) {
                            return;
                        }

                        let reportTemplate = new Drilldown(config.reportTemplateList().find(x => x.id === e.value));
                        reportTemplate.order = tabOrWidget.drilldownManager.activeDrilldownIndex() + 1;

                        let existingDrilldown = tabOrWidget.drilldownManager.drilldownList().find(x => x.id === e.value && x.order > tabOrWidget.drilldownManager.activeDrilldownIndex() + 1);
                        if (existingDrilldown) {
                            tabOrWidget.drilldownManager.drilldownList.remove(existingDrilldown);
                            tabOrWidget.drilldownManager.drilldownList.replace(tabOrWidget.drilldownManager.getNextDrilldown(), reportTemplate);
                            let order = 0;
                            for (let drilldown of tabOrWidget.drilldownManager.drilldownList()) {
                                drilldown.order = order++;
                            }
                        }
                        else {
                            let nextDrilldown = tabOrWidget.drilldownManager.getNextDrilldown();
                            if (nextDrilldown) {
                                //replace the next drilldown for the new one selected
                                tabOrWidget.drilldownManager.drilldownList.replace(nextDrilldown, reportTemplate);
                            }
                            else {
                                //at this point, there shouldn't be next drilldown, so add to the last position and set the next drilldown id
                                tabOrWidget.drilldownManager.drilldownList.push(reportTemplate);
                            }
                        }

                        if (!reportTemplate.isAggregative) {
                            tabOrWidget.drilldownManager.drilldownList.splice(tabOrWidget.drilldownManager.activeDrilldownIndex() + 2);
                        }
                        
                        tabOrWidget.drilldownManager.nextDrilldownId(e.value);
                        tabOrWidget.drilldownManager.saveDrilldownList(e.element);

                        tabOrWidget.reportConfig?.updateDrilldownListRemovingTemplateId(tabOrWidget);
                    },
                    displayExpr(e: Drilldown) {
                        return replaceBasicHtmlContent(e?.name);
                    },
                    valueExpr: "id",
                    disabled: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        let tabOrWidget = this();

                        if (tabOrWidget.tabOrWidget === TabOrWidgetEnum.Tab && config.activeTab().tabType() === TabTypeEnum.Dashboard) {
                            return true;
                        }

                        let activeWidget = tabOrWidget.drilldownManager.getActiveWidget();

                        if (!activeWidget) {
                            return false;
                        }

                        return activeWidget.disableDrilldown || !(tabOrWidget.drilldownManager.getActiveDrilldown()?.isAggregative ?? true);
                    }, config.activeTabOrWidget),
                    dropDownOptions: {
                        hideOnOutsideClick: true,
                        title: "Report Templates",
                        width: 220,
                        toolbarItems: [{
                            widget: "dxButton",
                            location: "after",
                            options: {
                                icon: "ms ir-sort-by-alpha-icon",
                                hint: "Sort alphabetically",
                                elementAttr: {
                                    class: `ir-sort-fields ${loggedUser.alphabeticalOrder ? "selected" : ""}`
                                },
                                onClick(e) {
                                    loggedUser.alphabeticalOrder = !loggedUser.alphabeticalOrder;
                                    if (e.element.hasClass("selected")) {
                                        e.element.removeClass("selected");
                                    }
                                    else {
                                        e.element.addClass("selected");
                                    }

                                    forceUpdateDataSource(!forceUpdateDataSource());
                                }
                            }
                        }]
                    },
                },
            },
            {
                location: 'before',
                widget: 'dxButton',
                locateInMenu: window.innerWidth <= 500 ? "always" : "never",//Hack to fix the button position on mobile because we overwrite to display:flex for the drilldown filters to work
                options: {
                    elementAttr: {
                        class: "intro-drilldown-edit",
                    },
                    hint: 'Edit default drill-down list',
                    template: `<i class="ms">edit_note</i> Edit`,
                    onClick(e) {
                        if (!isMobile()) {
                            editPopupControl.option({
                                'position.of': e.element,
                            } as Partial<DevExpress.ui.dxPopup.Properties>);
                        }
                        editPopupControl.show();
                    },
                    disabled: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        let tabOrWidget = this();

                        if (tabOrWidget.tabOrWidget === TabOrWidgetEnum.Tab && config.activeTab().tabType() === TabTypeEnum.Dashboard) {
                            return true;
                        }

                        let activeWidget = tabOrWidget.drilldownManager.getActiveWidget();

                        if (!activeWidget) {
                            return false;
                        }

                        return activeWidget.disableDrilldown;
                    }, config.activeTabOrWidget)
                },
                visible: loggedUser.permissions.workbooks() || workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted
            },
            {
                location: 'before',
                widget: 'dxButton',
                locateInMenu: window.innerWidth <= 500 ? "always" : "never",//Hack to fix the button position on mobile because we overwrite to display:flex for the drilldown filters to work
                options: {
                    width: 100,
                    hint: 'Show drilldown filters',
                    template: `<i class="ms">filter_alt</i> Show Filters`,
                    onClick(e) {
                        workbook.workbookConfig.generalSettings.drawerWorkbookSideBars.show();
                        Ir.Components.Workbook.WorkbookSideTabs.goToDrilldownTab();
                    }
                },
                visible: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                    if (!isMobile()) {
                        return false;
                    }

                    if (this()) {
                        if (this().tabOrWidget == TabOrWidgetEnum.Widget || (this().tabOrWidget == TabOrWidgetEnum.Tab && config.activeTab().tabType() !== TabTypeEnum.Dashboard)) {
                            return this().drilldownManager.isDrilldown;
                        }
                    }

                    return false;
                }, config.activeTabOrWidget)
            },
            {
                location: 'before',
                template(itemData, itemIndex, element) {
                    $('<div>')
                        .addClass('toolbar-separator')
                        .appendTo(element);
                },
                menuItemTemplate(itemData, itemIndex, element) {
                    $('<div>')
                        .addClass('toolbar-menu-separator')
                        .appendTo(element);
                },
                visible: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                    if (isMobile()) {
                        return false;
                    }

                    if (this()) {
                        if (this().tabOrWidget == TabOrWidgetEnum.Widget || (this().tabOrWidget == TabOrWidgetEnum.Tab && config.activeTab().tabType() !== TabTypeEnum.Dashboard)) {
                            return this().drilldownManager.isDrilldown;
                        }
                    }

                    return false;
                }, config.activeTabOrWidget)
            },            
            {
                location: 'before',
                cssClass: "toolbar-item-drilldown-filter",
                template: () => {
                    let $div = $(`<drilldown-filters params="isToolbar: isToolbar"></drilldown-filters>`);
                    ko.applyBindings({ isToolbar: true }, $div.get(0));
                    return $div;
                },
                visible: !isMobile()
            }
        ];

        return items;
    }
}